module.exports = __webpack_public_path__ + "static/media/crop3.6d654912.png";